import React from 'react';
import { ButtonGroup, Button, Card, CardBody, CardTitle } from 'reactstrap';
import ButtonAction from './ButtonAction';

export default class SidebarPanel extends React.PureComponent {
  render() {
    return (<Card className="sidebar-panel">
      <CardBody>
        <CardTitle>
          <span className="sidebar-title-box">
            {this.props.title}
            <span className="sidebar-fade">&nbsp;</span>
          </span>
          <ButtonGroup>
            {this.props.download}
            <Button
              tag="a"
              title="dismiss"
              color="secondary"
              onClick={this.props.dismiss}
            >
              <i className="fa fa-remove" />
            </Button>
          </ButtonGroup>
        </CardTitle>
      </CardBody>
      <CardBody>
        {this.props.children}
      </CardBody>
    </Card>);
  }
}
